import Tooltip from '@components/common/tooltip'
import GroupClassRescheduleTooltipContent from '@components/reschedule-course-class/group-class-reschedule-tooltip-content'
import RescheduleClassModal from '@components/reschedule-course-class/reschedule-class-modal'
import { StudentProps } from '@lib/types/classroom'
import { RelationshipManagerType } from '@lib/types/common'
import { First8Type } from '@components/common/first-8-badge'
import classNames from 'classnames'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { AlertTriangle } from 'react-feather'

type Props = {
  classes?: string
  lessonNumber?: string | number
  lessonTitle: string
  teacherCalendarId: number
  batchId: string
  classroomId: number | string
  classStartTime: string
  relationshipManager: RelationshipManagerType
  setIsOutsideClickDisabled?: Dispatch<SetStateAction<boolean>>
  studentDetails?: StudentProps
  isGroupClass?: boolean
  first8?: First8Type | null
}

/** Opens reschedule modal on click */
const RescheduleClassButton = ({
  classes,
  lessonNumber,
  lessonTitle,
  teacherCalendarId,
  batchId,
  classroomId,
  classStartTime, // ISO formatted time
  relationshipManager,
  setIsOutsideClickDisabled,
  studentDetails,
  isGroupClass = false,
  first8,
}: Props) => {
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false)

  useEffect(() => {
    setIsOutsideClickDisabled?.(isRescheduleModalOpen)
  }, [isRescheduleModalOpen])

  const rescheduleCTA = 'Reschedule class'

  return (
    <>
      <RescheduleClassModal
        isOpen={isRescheduleModalOpen}
        setIsOpen={setIsRescheduleModalOpen}
        lessonNumber={lessonNumber}
        lessonTitle={lessonTitle}
        teacherCalendarId={teacherCalendarId}
        batchId={batchId}
        classroomId={classroomId}
        classStartTime={classStartTime}
        relationshipManager={relationshipManager}
        studentDetails={studentDetails}
        first8={first8}
      />
      {isGroupClass && (
        <Tooltip
          content={
            <GroupClassRescheduleTooltipContent
              relationshipManager={relationshipManager}
            />
          }
          className="flex items-center space-x-1 cursor-pointer select-none text-grey-700 font-600"
          showOnHover
        >
          <AlertTriangle width={16} />
          <p>{rescheduleCTA}</p>
        </Tooltip>
      )}
      {!isGroupClass && (
        <button
          className={classNames(
            'text-orange font-600 hover:underline focus:outline-none flex-shrink-0',
            classes
          )}
          onClick={() => setIsRescheduleModalOpen(true)}
        >
          {rescheduleCTA}
        </button>
      )}
    </>
  )
}

export default RescheduleClassButton
